import axios from "axios";
import { aiAnalyticsUrl, preProdToken } from "../constants/apis";

export const getAIAnalytics = async (startDate = null, endDate = null) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${preProdToken}`,
        },
    };

    let url = aiAnalyticsUrl;
    if (startDate && endDate) {
        url += `?start_date=${startDate}&end_date=${endDate}`;
    }

    const response = await axios.get(url, config);
    return response;
};
